module.exports = __webpack_public_path__ + "static/media/tick.2ab9e18d.png";